import { gql, Reference, useMutation } from '@apollo/client'

import type { GQL_ID } from '@@types'

type RemoveFavoriteProductVariables = {
  product_id: GQL_ID
}

export const GQL_MUTATION_REMOVE_FAVORITE_PRODUCT = gql`
  mutation removeFavoriteProduct ($product_id: ID!) {
    removeFavoriteProduct(product_id: $product_id)
  }
`

export const useMutateRemoveFavoriteProduct = () => {
  return useMutation<boolean, RemoveFavoriteProductVariables>(GQL_MUTATION_REMOVE_FAVORITE_PRODUCT, {
    update: (cache, _result, options) => {
      const productId = options.context?.productId
      if (!productId) return

      cache.modify({
        id: `Product:${productId}`,
        fields: {
          isFavorite: () => false,
        },
      })

      cache.modify({
        fields: {
          favoriteProducts (existing, { readField }) {
            if (!existing?.edges) return existing

            return {
              ...existing,
              edges: existing.edges.filter(
                (edge: Reference) => readField('id', edge) !== productId,
              ),
            }
          },
        },
      })

      cache.modify({
        fields: {
          favoriteProducts (existing = {}) {
            return {
              ...existing,
              pageInfo: {
                ...existing.pageInfo,
                total: (existing.pageInfo?.total ?? 0) - 1,
              },
            }
          },
        },
      })
    },
  })
}
